<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="col-6 pl-0">
    <p class="titleFont">
      {{ "label.claim.claimDetails.occupationDetails" | translate }}
    </p>
  </div>
  <div class="card mt-2 pl-4 pr-5 pt-4 pb-4" [ngStyle]="{ 'pointer-events':  'none' }">
    <!--Row 1-->
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
        <p>
          {{ "label.claim.claimDetails.noOfPartners/Employees" | translate }}
        </p>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 px-0">
        <custom-input-text
          digitOnly
          [model]="occupationModule?.numberOfEmployees"
          [disabled]="true"
        >
        </custom-input-text>
      </div>
    </div>
    <!--Row 2-->
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
        <p>
          {{ "label.claim.claimDetails.businessOperationCeased" | translate }}
        </p>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 toggle-group-btn px-0">
        <custom-toggle-group
          class="toggle-section"
          margin="xxsmall"
          (valueChange)="onChangeValue($event, 'selfEmployed')"
          [value]="occupationModule.periodOfDisability"
          [listToggle]="commonToggleList"
        >
        </custom-toggle-group>
      </div>
    </div>
    <!--Row 3-->
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
        <p>
          {{ "label.claim.claimDetails.businessGeneratedIncome" | translate }}
        </p>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 toggle-group-btn px-0">
        <custom-toggle-group
          class="toggle-section"
          margin="xxsmall"
          (valueChange)="onChangeValue($event, 'selfEmployed')"
          [value]="occupationModule.incomeSinceTheDisability"
          [listToggle]="commonToggleList"
        >
        </custom-toggle-group>
      </div>
    </div>
  </div>

  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'label.claim.claimDetails.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'label.claim.claimDetails.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>
